module.exports = __webpack_public_path__ + "img/shadow-btn1@2x.f12cb775.png";